import { generateClient } from 'aws-amplify/api';

export const client = generateClient();

export const timer = (ms) => new Promise((res) => setTimeout(res, ms));
